import { createContext, useContext } from 'react'

import { QuickPassNotificationsContextValue } from './quickpass-notifications-context-types'

const QuickPassNotificationsContext =
  createContext<QuickPassNotificationsContextValue | null>(null)

/**
 * Reads the current notifications state. Throws if used outside a
 * `QuickPassNotificationsProvider`.
 *
 * @returns {QuickPassNotificationsContextValue}
 */
const useQuickPassNotifications = (): QuickPassNotificationsContextValue => {
  const context = useContext(QuickPassNotificationsContext)

  if (context === null) {
    throw new Error(
      'useQuickPassNotifications must be used within a QuickPassNotificationsProvider',
    )
  }

  return context
}

export { QuickPassNotificationsContext, useQuickPassNotifications }
